import React, { useEffect, useState } from 'react';
import BlogBanner from '../../components/BlogBanner';
import BlogSection from '../../components/BlogSection';
import { getSeoByUrl } from '../../api/api';

const Blog = () => {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("blog"); 
        
        if (response.success && response.data) {
          setSeoData(response.data);
          updateMetaTags(response.data);
          console.log("Blog page SEO loaded:", response.data.metaTitle);
        } else {
          console.log("No SEO data found, using default SEO for Blog page");
          const defaultSeo = {
            metaTitle: "Blog - Nutrition Tips, DNA Based Diet Plans & Wellness Advice | Nutrillion",
            metaDescription: "Read expert blogs on personalized nutrition, DNA-based diet plans, genetic testing, wellness tips, and healthy living from Nutrillion's nutritionists.",
            robotsTxt: "index, follow",
            canonicalUrl: "https://nutrillion.one/blog",
            metaKeywords: "nutrition blog, DNA diet, wellness tips, healthy living, personalized nutrition"
          };
          updateMetaTags(defaultSeo);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeoData();
  }, []);

  const updateMetaTags = (data) => {
    if (data.metaTitle) document.title = data.metaTitle;
        let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (data.metaDescription) metaDesc.setAttribute('content', data.metaDescription);
        if (data.metaKeywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', data.metaKeywords);
    }
        let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    if (data.robotsTxt) robotsMeta.setAttribute('content', data.robotsTxt);
        let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    if (data.canonicalUrl) canonicalLink.setAttribute('href', data.canonicalUrl);
        if (data.schemaMarkup) {
      let existingScript = document.querySelector('#schema-markup');
      if (existingScript) existingScript.remove();
      
      const script = document.createElement('script');
      script.id = 'schema-markup';
      script.type = 'application/ld+json';
      script.textContent = data.schemaMarkup;
      document.head.appendChild(script);
    }
  };

  return (
    <div>
      <BlogBanner />
      <BlogSection />
    </div>
  );
};

export default Blog;